<template>
  <div class="myModel" v-if="isPlayDemoVideo">
    <circleClose class="icon closeVideoBtn" @click="closeVideo"></circleClose>
    <h3 class="video-title">{{videoTtitle}}</h3>
    <video-play-com
      v-if="previewType == 'video'"
      :isPlayDemoVideo="isPlayDemoVideo"
      :videoUrl="previewUrl"
      :fullScreen="true"
    ></video-play-com>
    <img
      v-if="previewType == 'image'"
      alt="图片加载失败"
      style="max-width: 100%;max-height;: 100%;margin:0 auto"
      :src="previewUrl"
    />
  </div>
</template>

<script>
import VideoPlayCom from '@/components/VideoPlayCom'
import { circleClose } from '@/core/icons'
export default {
  components: {
    VideoPlayCom,
    circleClose,
  },
  props: {
    isPlayDemoVideo: {},
    previewUrl: {},
    previewType: {
      default: 'video',
    },
    videoTtitle: {}
  },
  methods: {
    closeVideo(e) {
      this.$emit('update:isPlayDemoVideo', false)
    },
  },
}
</script>

<style lang="less" scoped>
.myModel {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  overflow: hidden;
  text-align: center;
}
.closeVideoBtn {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 999;
  cursor: pointer;
}
.icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.video-title{
  position: fixed;
  width:100%;
  background:rgba(0,0,0,0.4);
  color:#fff;
  padding:5px;
  margin:0;
  z-index:998;
  top:0;
}
</style>